module.exports = __webpack_public_path__ + "static/media/at.d9458329.svg";